import React, { Component } from 'react';

//styles
import './sectionSeven.scss';
import '../../static/fonts/Rubik/stylesheet.css'

class SectionSeven extends Component {
    componentDidMount() {
        this.props.renderPlaybazz();
    }

    render() {
        return (
            <div id="section7" className="section7-container">
                <div className="inner-desc">
                    <div className="title">האם אני עני חדש?</div>
                    <div className="desc">בחנו את עצמכם</div>
                    <div className="game">
                    <div className="playbuzz" data-id="f8eb934a-59c7-4e75-a431-f1875953efe0" data-show-share="false" data-show-info="false"></div>
                </div>
                </div>
                
                <div className="desc-container">
                </div>
            </div>
        );
    }
}

export default SectionSeven;


// WEBPACK FOOTER //
// ./src/Components/SectionSeven/SectionSeven.js